import React from 'react';
import cn from 'classnames';
import isEqual from 'lodash/isEqual';
import {
  SelectOptionWithCountryFlag,
  SelectSingleValueWithCountryFlag,
} from '@dealroadshow/uikit-select/components';

import { Select } from '@framework/ui/Organisms/FinalForm/Fields/Select';
import { Field } from '@framework/ui/Organisms/FinalForm';

import { mapOptionToValue } from '@framework/data-helpers/selectOptionMappers';
import { useDialInCountriesTableContext } from '../DialInCountriesTableContext';
import { useCallFormContext } from '../../CallFormContext';

import { getDialInCountriesTableSelectLayoutProps } from '../helpers';
import { IDialInCountryTableRowItem } from '../interfaces';
import { CallFormInstance } from '../../interfaces';

import styles from '../dialInCountriesTable.module.scss';

interface IProps {
  row: IDialInCountryTableRowItem,
  isMobile?: boolean,
}

const CountryIdField = (
  {
    row,
    isMobile,
  }: IProps,
) => {
  const {
    disabled,
    countryOptions,
  } = useDialInCountriesTableContext();
  const { instance } = useCallFormContext();
  return (
    <Field
      name={ `${ row.fieldName }.countryId` }
      render={
        ({ input, meta }) => (
          // @ts-ignore
          <Select
            { ...getDialInCountriesTableSelectLayoutProps(isEqual(instance, CallFormInstance.ScheduleYourCall)) }
            // @ts-ignore
            isNarrow
            input={ input }
            meta={ meta }
            isClearable={ false }
            isDisabled={ disabled }
            placeholder="Select Country"
            options={ countryOptions }
            dataTest={ `countryId${ isMobile ? 'Mobile' : '' }` }
            // makes option non-selectable
            isOptionDisabled={ (option) => option.disabled }
            // add country flags to options and value
            components={
              {
                Option: SelectOptionWithCountryFlag,
                SingleValue: SelectSingleValueWithCountryFlag,
              }
            }
            // applies phone code and styles for option and value
            formatOptionLabel={ ({ label, disabled, phoneCode, value }) => {
              const labelCls = cn(
                {
                  [styles.disabledOptionCountryName]: (
                    disabled && !isEqual(mapOptionToValue(input.value), value)
                  ),
                },
              );
              return (
                <>
                  <span className={ labelCls }>{ label }</span>
                  <span className={ styles.countryOptionPhoneCode }>{ phoneCode }</span>
                </>
              );
            } }
          />
        )
      }
    />
  );
};

export default CountryIdField;
